import styled from "styled-components";

const PluginSpacing = styled.div`
  margin-bottom: var(--tina-padding-big);
`;

export default PluginSpacing;